<!-- Single-modal render. The selected template is shown DIRECTLY inside this
     component's own modal container, chosen by modalName. Previously ngOnInit()
     opened a SECOND modal to display these templates, so every popup was two
     stacked <modal-container>s (an empty hidden "host" + the visible "inner").
     Closing hid both, and they tore down on different timers — which looked like
     "two popup screens closing". Rendering inline collapses it to ONE modal, one
     backdrop, one clean close for both the × and the Close button.
     modalName is undefined for the customer-plan popup, so nothing renders there
     — exactly as before. -->
<ng-container *ngIf="modalName === 'PAY'" [ngTemplateOutlet]="modalTemplate"></ng-container>
<!-- `&& upgradeForm`: upgradeForm is built by upgradefunction() only AFTER the
     `await getPoints()` in ngOnInit, but this outlet renders as soon as modalName
     is 'UPGRADE'. Without the guard the upgradejob template binds
     [formGroup]="undefined" during that async window → NG01052 + "Cannot read
     'get' of undefined". Render the form only once it exists. -->
<ng-container *ngIf="modalName === 'UPGRADE' && upgradeForm" [ngTemplateOutlet]="upgradejob"></ng-container>
<ng-container *ngIf="modalName === 'LIMIT'" [ngTemplateOutlet]="limitReached"></ng-container>

<ng-template #modalTemplate>
  <div class="common-header-flex">
    <div> {{ModelContent.headerName}} Exhausted </div>
    <button>
      <span (click)="close()" class="common-close">×</span>
    </button>
  </div>

  <div class="expiration-modal-container">
    <div class="content-body">
      <div class="current-plan-snippet ">
        {{ModelContent.body}} <span class="plan-texture"> {{MemberShipType}}</span> plan.
      </div>
      <div class="plan-detail">
        {{ModelContent.planDetail}}
      </div>
      <div class="plan-version-container">
        <div class="plan-max">
          <div>{{ModelContent.planMax}}</div>
          <div class="plan-value">{{actualcredits}}</div>
        </div>
        <!-- Promotional column removed from exhaust popups (kept out of all slot/credit exhaustion dialogs) -->
        <div class="slots-used">
          <div>{{ModelContent.slotsUsed}}</div>
          <div class="plan-value">{{utilizedcredits}}</div>
        </div>
        <div class="available-provision">
          <div>{{ModelContent.availableProvision}}</div>
          <div class="plan-value">{{availablecredits}}</div>
        </div>
      </div>
      <div class="plan-procedure-container">
        <div *ngIf="ModelContent.planExtensionSnippet" class="plan-extension-snippet">
          {{ModelContent.planExtensionSnippet}}</div>
        <div *ngIf="ModelContent.planExtensionDetail1" class="plan-extension-detail-1">
          {{ModelContent.planExtensionDetail1}}</div>
        <div *ngIf="ModelContent.planExtensionDetail2" class="plan-extension-detail-2">
          {{ModelContent.planExtensionDetail2}}</div>
        <div *ngIf="ModelContent.planExtensionDetail3" class="plan-extension-detail-3">
          {{ModelContent.planExtensionDetail3}}</div>
      </div>

      <div *ngIf="ModelContent.psNote" class="ps-note" [innerHtml]="ModelContent.psNote"></div>
    </div>
  </div>

  <div class="expiration-modal-footer">
    <button *ngIf="MemberShipType!='ScaleX'" type="button" class="btn btn-default" (click)="close()"> Cancel </button>
    <button *ngIf="showManage()" type="button" class="btn  btn-primary" (click)="routeTo()">
     {{getButtonName()}}
  </button>
    <button
    type="button"
    class="btn  btn-primary"
    (click)="MemberShipType === 'ScaleX' ? close() : upgradePlan()">
    {{ MemberShipType === 'ScaleX' ? 'Ok' : 'Upgrade' }} </button>

    <!-- to
      Pro ${{PlanConsumePoints}}/month  -->
    <!-- <button type="button" class="btn  btn-primary" *ngIf="isPayAsYouGo(content)"> Pay as you go
      ${{CreditConsumePoints}}/view </button> -->
  </div>
</ng-template>

<ng-template #limitReached>
  <div class="common-header-flex">
    <div>{{ ModelContent.headerName === 'Jobs / Candidate Slots ' ? 'No available slots' : 'Not Enough ' + ModelContent.headerName }}</div>
    <button type="button" (click)="close()">
      <span class="common-close">×</span>
    </button>
  </div>
  <div class="limit-modal-container">
    <div class="content-body">
      <div class="plan-version-container">
        <div class="plan-max">
          <div>Allocated</div>
          <div class="plan-value">{{actualcredits}}</div>
        </div>
        <!-- Promotional column removed from exhaust popups (kept out of all slot/credit exhaustion dialogs) -->
        <div class="slots-used">
          <div>Used</div>
          <div class="plan-value">{{utilizedcredits}}</div>
        </div>
        <div class="available-provision">
          <div>Available</div>
          <div class="plan-value">{{availablecredits}}</div>
        </div>
      </div>
      <div class="procedure-container">
        <!-- Interaction Credits exhaustion — recharged by the Super Admin, not self-recharged -->
        <div class="plan-extension-snippet" *ngIf="ModelContent.headerName === 'Interaction Credits '">
          Your Interaction Credits have been exhausted. Please contact your Super Admin to allocate more Interaction Credits.
        </div>
        <div  class="plan-extension-snippet" *ngIf="ModelContent.headerName !== 'Jobs / Candidate Slots ' && ModelContent.headerName !== 'Interaction Credits '">
          You don't have enough slots. Your slots has to be recharged if you want to create more {{ModelContent.headerName}}.
        </div>

        <div class="slot-options-block" *ngIf="ModelContent.headerName === 'Jobs / Candidate Slots '">
          <div class="slot-options-intro">
            You have used all your available slots
          </div>
          <!-- Free plan surfaces two options (deactivate + upgrade) as a numbered
               list; every other role gets the single deactivate action. -->
          <ng-container *ngIf="isFreePlan">
            <div class="slot-options-note">1. {{ deactivateInstruction }}</div>
            <div class="slot-options-note">2. Upgrade to a higher plan</div>
          </ng-container>
          <div class="slot-options-note" *ngIf="!isFreePlan">{{ deactivateInstruction }}</div>

          <!-- Deactivate section — the primary action, always expanded. -->
          <div class="slot-accordion-item is-open">
            <div class="slot-accordion-header active no-toggle">
              <span class="slot-accordion-question">{{ (isFreePlan ? '1. ' : '') + deactivateSectionTitle }}</span>
            </div>
            <div class="slot-accordion-content expanded">
              <div class="slot-accordion-body">
                <!-- Jobs/Candidates radio only when the role handles both. -->
                <div class="slot-subtype-toggle" *ngIf="showSlotSubTypeToggle">
                  <label>
                    <input type="radio" name="slotSubType" value="JOBS"
                      [checked]="slotSubType === 'JOBS'"
                      (change)="onSlotSubTypeChange('JOBS')">
                    <span>Jobs</span>
                  </label>
                  <label>
                    <input type="radio" name="slotSubType" value="CANDIDATES"
                      [checked]="slotSubType === 'CANDIDATES'"
                      (change)="onSlotSubTypeChange('CANDIDATES')">
                    <span>Candidates</span>
                  </label>
                </div>

                <!-- No radio (single-type role): label the list explicitly. -->
                <div class="slot-list-header" *ngIf="!showSlotSubTypeToggle">
                  {{ slotSubType === 'JOBS' ? 'My Jobs' : 'My Candidates' }}
                </div>

                <div class="active-items-list">
                  <div class="active-list-loading" *ngIf="loadingActiveList">Loading…</div>

                  <ng-container *ngIf="slotSubType === 'JOBS' && !loadingActiveList">
                    <div class="active-empty" *ngIf="activeJobs.length === 0">
                      You have no active jobs to deactivate.
                    </div>
                    <div class="active-item-row" *ngFor="let job of activeJobs">
                      <div class="active-item-title" [title]="jobDisplayTitle(job)">{{ jobDisplayTitle(job) }}</div>

                      <!-- Blocked is a terminal state — same toggle shape but
                           disabled, coloured from FormValidation.getStyle('BLOCKED'). -->
                      <button *ngIf="job?.status === 'BLOCKED'" type="button" disabled
                              class="jc-slot-toggle is-off is-blocked job"
                              [ngStyle]="formValidation.getStyle('BLOCKED')">
                        <span class="jc-slot-toggle-label">Blocked</span>
                        <span class="jc-slot-toggle-knob"></span>
                      </button>

                      <!-- Active/On Hold toggle. Turning off frees a slot; an
                           off job can only be switched back on once a slot is
                           free (hasAvailableSlot), so it's disabled otherwise. -->
                      <button *ngIf="job?.status !== 'BLOCKED'" type="button"
                              class="jc-slot-toggle job"
                              [class.is-on]="isJobActive(job)"
                              [class.is-off]="!isJobActive(job)"
                              [disabled]="!isJobActive(job) && !hasAvailableSlot"
                              [title]="(!isJobActive(job) && !hasAvailableSlot) ? 'Free up a slot to reactivate' : ''"
                              (click)="onJobToggle(job)">
                        <span class="jc-slot-toggle-label">{{ jobToggleLabel(job) }}</span>
                        <span class="jc-slot-toggle-knob"></span>
                      </button>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="slotSubType === 'CANDIDATES' && !loadingActiveList">
                    <div class="active-empty" *ngIf="activeCandidates.length === 0">
                      You have no active candidates to mark unavailable.
                    </div>
                    <div class="active-item-row" *ngFor="let candidate of activeCandidates">
                      <div class="active-item-title" [title]="candidateDisplayName(candidate)">{{ candidateDisplayName(candidate) }}</div>

                      <!-- Blocked is a terminal state — same toggle shape but
                           disabled, coloured from FormValidation.getStyle('BLOCKED'). -->
                      <button *ngIf="candidate?.status === 'BLOCKED'" type="button" disabled
                              class="jc-slot-toggle is-off is-blocked candidate"
                              [ngStyle]="formValidation.getStyle('BLOCKED')">
                        <span class="jc-slot-toggle-label">Blocked</span>
                        <span class="jc-slot-toggle-knob"></span>
                      </button>

                      <!-- Available/Unavailable toggle. Same free-a-slot rule
                           as jobs: reactivation is disabled until a slot frees. -->
                      <button *ngIf="candidate?.status !== 'BLOCKED'" type="button"
                              class="jc-slot-toggle candidate"
                              [class.is-on]="isCandidateActive(candidate)"
                              [class.is-off]="!isCandidateActive(candidate)"
                              [disabled]="!isCandidateActive(candidate) && !hasAvailableSlot"
                              [title]="(!isCandidateActive(candidate) && !hasAvailableSlot) ? 'Free up a slot to reactivate' : ''"
                              (click)="onCandidateToggle(candidate)">
                        <span class="jc-slot-toggle-label">{{ candidateToggleLabel(candidate) }}</span>
                        <span class="jc-slot-toggle-knob"></span>
                      </button>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <!-- Upgrade plan — free plan only (option 2). Other roles free slots
               by deactivating; "Assign more slots" was removed per the redesign. -->
          <div *ngIf="isFreePlan" class="slot-accordion-item" [class.is-open]="selectedSlotOption === 'UPGRADE'">
            <div class="slot-accordion-header"
                 [class.active]="selectedSlotOption === 'UPGRADE'"
                 (click)="onSlotOptionChange('UPGRADE')">
              <span class="slot-accordion-question">2. Upgrade to a higher plan</span>
              <ng-icon name="tablerChevronDown" class="slot-accordion-icon" [class.rotated]="selectedSlotOption === 'UPGRADE'"></ng-icon>
            </div>
            <div class="slot-accordion-content" [class.expanded]="selectedSlotOption === 'UPGRADE'">
              <div class="slot-accordion-body">
                <button type="button" class="btn btn-primary slot-option-cta" (click)="goToPlanQuota()">
                  Upgrade Plan →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="expiration-modal-footer">
    <button type="button" class="btn  btn-primary" (click)="close()">
      {{ ModelContent.headerName === 'Jobs / Candidate Slots ' ? 'Close' : 'Ok' }}
    </button>
  </div>
</ng-template>

<ng-template #upgradejob>
  <div class="common-header-flex">
    <div>{{ModelContent.headerName}} </div>
    <button type="button">
      <span (click)="close()" class="common-close">×</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="upgradeForm" (ngSubmit)="redeemthecredits(upgradeDetails)">
      <div class="row">
        <div class="custom-checkbox col-sm-6" style="padding-bottom: 28px;">
          <label style="margin-top:5px;">
            <b>Redeem Sumo Credits</b> </label>
          <input type="radio" value="redeemsumocredits" #redeemsumocredits
            [checked]="redeemsumocredits.value === selectedValue" (change)="onItemChange($event.target.value)"
            formControlName="redeemsumocredits">
        </div>
        <!-- <div class="custom-checkbox col-sm-6 ">
          <label style="margin-top:5px;"> <b> Pay as you go</b></label>
          <input type="radio" [(ngModel)]="clearSelectedValues" value="payasyogo" #payasyogo
            [checked]="payasyogo.value === selectedValue" (change)="onItemChange($event.target.value)"
            formControlName="payasyogo">
        </div> -->
      </div>
      <div class="row">
        <div class="form-group col-sm-6" style="padding-bottom: 9px;">
          <label class="control-label required-field font-bold" for="upgradefor">For</label>
          <input  type="text" placeholder="Upgrade Job" class="form-control" formControlName="upgradefor" />

        </div>
        <div class="col-sm-6" *ngIf="selectedValue=='redeemsumocredits'">
          <label class="control-label required-field font-bold" for="dropdownSelection">Days</label>
          <ng-select [(ngModel)]="selectedDay"
            [ngClass]="{ 'is-invalid': submitted && upgradeForm.controls.limit.errors }" formControlName="limit"
            placeholder="Selected No of Days">
            <ng-option *ngFor="let day of days" [value]="day">{{ day }}</ng-option>
          </ng-select>
          <div *ngIf="submitted && upgradeForm.controls.limit.errors" class="error-msg ps-init">
            <div *ngIf="upgradeForm.controls.limit.errors.required">No of days is required</div>
          </div>
        </div>
        <div class="col-sm-6" *ngIf="selectedValue=='payasyogo'">
          <label class="control-label required-field font-bold" for="dropdownSelection">Days</label>
          <ng-select [(ngModel)]="selectedDay"
            [ngClass]="{ 'is-invalid': submitted && upgradeForm.controls.paylimit.errors }" formControlName="paylimit"
            placeholder="Selected No of Days">
            <ng-option *ngFor="let day of days" [value]="day">{{ day }}</ng-option>
          </ng-select>
          <div *ngIf="submitted && upgradeForm.controls.paylimit.errors" class="error-msg ps-init">
            <div *ngIf="upgradeForm.controls.paylimit.errors.required">No of days is required</div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="selectedValue=='redeemsumocredits'">
        <div class="form-group col-sm-6">
          <label class="control-label required-field font-bold" for="upgradefor">Available Sumo Credits </label>
          <input type="text"  placeholder="Available Sumo Credits" class="form-control"
            formControlName="availablesumocredits" />
        </div>
        <div class="form-group col-sm-6">
          <label class="control-label required-field font-bold" for="days">Redeem </label>
          <input id="points"  type="text" placeholder="0" class="form-control" formControlName="points" />
        </div>
      </div>
      <div *ngIf="selectedValue=='payasyogo'" class="row">
        <div class="form-group col-sm-6">
          <label class="control-label required-field font-bold" for="upgradefor">Rate per day </label>
          <input  type="text" placeholder="Rate per day" class="form-control" formControlName="rateperday" />
        </div>
        <div class="form-group col-sm-6">
          <label class="control-label required-field font-bold" for="days">Total cost </label>
          <input id="days"  type="text" placeholder="0" class="form-control" formControlName="price" />
        </div>
      </div>
      <div class="pricing-table">
        <div class="bg-head-card info-foot-price" style="width: 1110px;  margin-top: 4px;">
          <p >*Feature slot is empty, you can still use credits to upgrade.</p>
          <p *ngIf="selectedValue=='redeemsumocredits'"> {{ModelContent.body}}</p>
          <p> *Becomes effective today.</p>
          <p *ngIf="selectedValue=='redeemsumocredits'"> *Check availability of GigSumo Credits for redeeming.</p>
          <p *ngIf="selectedValue=='redeemsumocredits'">*All credit redemptions are final.</p>
          <p *ngIf="selectedValue=='payasyogo'">*All purchases are final.</p>
        </div>
      </div>

      <div class="form-group form-check">
        <input type="checkbox" formControlName="acceptTerms" id="acceptTerms" class="form-check-input"
          [ngClass]="{ 'is-invalid': submitted && upgradeForm.controls.acceptTerms.errors }" />
        <label for="acceptTerms" class="form-check-label">I accept the <a target="_blank"
            href="{{ENVIRONMENT.ssrUrl}}web/terms-conditions.html"
            style="text-decoration:underline; color: rgb(87, 154, 242);"> terms and conditions</a></label>
        <div *ngIf="submitted && upgradeForm.controls.acceptTerms.errors" class="error-msg ps-init">Please accept the
          terms and conditions</div>
      </div>

      <div class="button-container">
        <button type="button" class="btn btn-default outline" style="margin-right: 23px;" (click)="close()">Cancel</button>
        <button [ngClass]="{'disabled': showdays ==0}" *ngIf="selectedValue=='redeemsumocredits'"
          class="btn  btn-primary" type="submit">
          Redeem
        </button>
        <button *ngIf="selectedValue=='payasyogo'" class="btn  btn-primary" type="submit">
          Continue
        </button>
      </div>

    </form>
  </div>
</ng-template>
